// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2j9uh","modalFooterButton":"ModalNotes_modalFooterButton__2a85x"};